module.exports = __webpack_public_path__ + "../resources/img/@temp_chart_line.4197d631.jpg";